//TODO: delete me!!!!
import React from 'react';
import APP_CONSTANTS from '../shared/constants/app_constants';
import ExpressionEditor from './ExpressionEditor';
import HTMLExpressionEditor from './HTMLExpressionEditor';

// TODO: move this to constants maybe? 
const mathOperators = [
  {id: 1, description: 'add', symbol: '+', example: '2 + 2 = 4'},
  {id: 2, description: 'subtract', symbol: '-', example: '5 - 3 = 2'},
  {id: 3, description: 'multiply', symbol: '*', example: '4 * 3 = 12'},
  {id: 4, description: 'divide', symbol: '/', example: ' 8 / 2 = 4'},
  {id: 5, description: 'remainder', symbol: '%', example: ' 9 % 5 = 4'},
  {id: 6, description: 'power', symbol: '**', example: ' 2 ** 3 = 8' }
]

import KEYS_PERMITTED_MATHEMATICAL_EDITOR from '../shared/constants/permitted_keycodes_for_math';

export default class ValueSettingExpressionRouter extends React.Component{

  constructor(props){
    super(props);
    const form_rule = props.form_rule;
    const targetAttributeId = props.form_rule.target_attribute_ids[0];
    const targetAttribute = props.keenform.form_attributes.find(fa =>fa.id === targetAttributeId);
    let optionValues;
    switch(targetAttribute.form_attribute_type){
      case APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.SINGLESELECT:
        optionValues = (form_rule.metadata && form_rule.metadata.option_values ? form_rule.metadata.option_values : undefined);
        break;
      case APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.MULTISELECT:
        optionValues = (form_rule.metadata && form_rule.metadata.option_values ? form_rule.metadata.option_values : []);
        break;
      default:
        //dont do anything
    }
    this.state = {
      option_values: optionValues,
      use_nocode_expression: props.form_rule.use_nocode_expression,
    };
  }

  getEditorForFreeform = (thisTargetAttribute) => {
    let validSourceFormAttributes = this.props.keenform.form_attributes;
    const targetAttributeID = this.props.form_rule.target_attribute_ids[0];
    const targetAttribute = this.props.keenform.form_attributes.find(fa => fa.id === targetAttributeID);
    switch(thisTargetAttribute.value_type){
      case APP_CONSTANTS.VALUE_TYPES.TEXT:
        if (thisTargetAttribute.form_attribute_type !== 'noninput') { // TODO: make const
          return (<ExpressionEditor
            form_rule={this.props.form_rule}
            keenform={this.props.keenform}
            target_attribute={targetAttribute}
            valid_character_set={false}
            topNote={<div>Enter text as well as vairables, which will be converted to values</div>}
            sideNote={<div>Type text, press buttons for interpreted variable values</div>}
          />);
        } else {
          return (<HTMLExpressionEditor 
            form_rule={this.props.form_rule}
            keenform={this.props.keenform}
            target_attribute={targetAttribute}
            valid_character_set={false}
            sideNote={<div>Type text, press buttons for interpreted variable values</div>}
            />);
        }
      case APP_CONSTANTS.VALUE_TYPES.FLOAT:
      case APP_CONSTANTS.VALUE_TYPES.INTEGER:
        validSourceFormAttributes = this.props.keenform.form_attributes
        return (<ExpressionEditor 
          form_rule={this.props.form_rule}
          keenform={this.props.keenform}
          target_attribute={targetAttribute}
          valid_character_set={KEYS_PERMITTED_MATHEMATICAL_EDITOR}
          topNote={<div>Type mathematical expression (i.e. 4 + 2) below<br />
            add variables by clicking form attribute buttons</div>}
          sideNote={<div>
            <h5><strong>VALID OPERATORS</strong></h5>
            <ul className='text-left list-group list-group-flush'>
            { mathOperators.map(operation => {
              return (<li
              className='list-group-item'
              key={operation.id}>
                <span className="badge badge-secondary">
                  <strong>{operation.symbol}</strong>
                </span> &nbsp;
                 ({operation.description}) ex. {operation.example}
              </li>)
            })}
            </ul>
          </div>}
          />);
      default:
        console.error('no condition for this form attribute value type on value setting');
        return <div>Should this happen?</div>;
    }
  }

  getInputForCustomFunction = () => {
    return (<div>
      <div>Input for custom function body</div>
      <div className="alert alert-warning">this is experimental feature - this input will convert into javascript embedded into a function. Code must return a value for the value setting rule.</div>
      <div>this code with be used to create a lambda function that will pass a javascript object key/value hash</div>
      <div className="mock-function-container">
        <pre>(formAttributeValues) =&gt; &#123;</pre>
        <pre>// the following code will be used to create a javascript function</pre>
        <div className="m-3">
          <textarea 
            className="form-control crt-mock-code-input"
            rows="6"
            defaultValue={this.props.form_rule.type_function_body} 
            name="form_rule[type_function_body]" 
            id="form_rule_type_function_body"
            style={{'marginLeft':'-15px'}} />
        </div>
        <pre>&#125;</pre>
      </div>
    </div>);
  }

  getOptionsForMultiSelect = (targetAttribute) => {
    return (<div className="container">
      <div className="form-group">
        <label htmlFor='metadata'>Set <span className="badge badge-secondary">{targetAttribute.name}</span> value to be:</label>
        <div className="checkbox-container">
        {targetAttribute.options.map((option) => {
          return (<div 
            key={option.uuid}
            className="selectable-option-container form-check" 
            onClick={() => {this.toggleMultiselect(option)}}>
            <input 
              type="checkbox"
              readOnly
              name="form_rule[metadata][option_values][]"
              checked={this.state.option_values.includes(option.uuid)}
              value={option.uuid} />
            <label className="form-check-label m-2">{option.value}</label>
          </div>);
        })}
        </div>
      </div>
    </div>);
  };

  getOptionsForSingleSelect = (targetAttribute) => {
    return (<div className="container">
      <div className='form-group'>
        <label htmlFor='metadata'>Set <span className="badge badge-secondary">{targetAttribute.name}</span> value to be:</label>
        <select
          name="form_rule[metadata][option_values]"
          value={this.state.option_values}
          onChange={(event) => {this.setState({option_values: event.value})}}
          className='form-control'>
          {targetAttribute.options.map(option => <option key={option.uuid} value={option.uuid}>{option.value}</option>)}
        </select>
      </div>
    </div>);
  };

  toggleMultiselect = (optionClicked) => {
    let optionValues = this.state.option_values;
    if (this.state.option_values.includes(optionClicked.uuid)){
      optionValues = this.state.option_values.filter(opt => opt !== optionClicked.uuid);
    } else {
      optionValues.push(optionClicked.uuid);
    }
    this.setState({option_values: optionValues});
  }

  toggleForEditorOnSelect = () => {
    return (<div>
      <div className="form-group">
        <label>Show expression editor: &nbsp;</label>
        <input
          type="checkbox"
          defaultChecked={this.state.use_nocode_expression}
          onChange={() => {
            this.setState({use_nocode_expression: !this.state.use_nocode_expression});
          }}
          />
        <input 
          type="hidden"
          name="form_rule[use_nocode_expression]"
          value={this.state.show_editor_for_select ? 1 : 0}
          />
      </div>
      { this.state.use_nocode_expression 
        ? <div className="badge bg-warning">This is experimental feature, please use cautiously</div>
        : undefined
      }
    </div>);
  }

  render(){
    const thisTargetAttributeId = this.props.form_rule.target_attribute_ids[0];
    const thisTargetAttribute = this.props.keenform.form_attributes.find((fa) => {
      return fa.id === thisTargetAttributeId;
    });
    if (!thisTargetAttributeId || !thisTargetAttribute){
      console.error('missing target attribute, this should not happen');
      return <div>something is missing</div>;
    } else {
      // add function text input
      if (this.props.form_rule.use_type_function) {
        return this.getInputForCustomFunction();
      } else {
        switch (thisTargetAttribute.form_attribute_type){
          case APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.SINGLESELECT:
            // show options for single select
            // TODO: allow for values to be set with free form editor
            const singleSelectValueSetter = ( this.state.use_nocode_expression 
              ? this.getEditorForFreeform(thisTargetAttribute)
              : this.getOptionsForSingleSelect(thisTargetAttribute) 
            );
            return (
              <React.Fragment>
                { this.props.current_user.is_admin // add feature flag eventually
                  ? this.toggleForEditorOnSelect()
                  : undefined
                }
                {singleSelectValueSetter}
              </React.Fragment>
            );
            // return this.getOptionsForSingleSelect(thisTargetAttribute);
          case APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.MULTISELECT:
            //one more
            return this.getOptionsForMultiSelect(thisTargetAttribute);
          case APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.FREEFORM:
          case APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.NON_INPUT:
            return this.getEditorForFreeform(thisTargetAttribute);
          case APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.DATEPICKER:
            // console.log('under construction');
            return <div className="alert alert-warning">Setting a date cannot be done using NO-CODE, use custom function instead.</div>;
          case APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.INLINE_STYLE:
          // case APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.NON_INPUT:
            // this wont do anything, and this should not be possible
            console.log('trying to set value for invalid form attribute type')
            return <span className="badge badge-danger">this is not possible</span>;
          default:
            //this wont do anything
            console.error('invalid target attribute for value setting rule');
            return undefined;
        }
      }
    } 

  }
}